import React from "react";
import {
  ControlLabel,
  Col,
  FormControl,
  FormGroup,
  Row,
} from "react-bootstrap";

import { Form } from "formik";
import styled from "styled-components";
import moment from "moment";
import ActivityState from "./ActivityState";

const LicenseColumn = styled(Col)`
  color: #7d858a;
`;

const LicenseRow = styled("div")`
  color: #7d858a;
`;

const EntitlementDetail = ({ entitlement }) => { 
  return (
    <Form className="form-horizontal">
      <dl className="dl-horizontal">
        <dt>Family</dt>
        <dd>{entitlement.family}</dd>

        <dt>Package Name</dt>
        <dd>{entitlement.packageName}</dd>

        <dt>Voucher Code</dt>
        <dd>{entitlement.voucherCode.toUpperCase()}</dd>
      </dl>
      <hr />
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Status
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.status}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Product Number
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.productNumber}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Last Activity
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.lastActivity}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Number of Unlock
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.numberOfUnlock}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Remaining Unlock
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.numberOfUnlockLeft}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Valid From
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.validFrom}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Valid To
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.validTo}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Usage Limit Type
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.usageLimitType}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Usage Limit
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.usageLimit}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Requires Online
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.requiresOnline.toString()}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Requires Login
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                {entitlement.requiresLogin.toString()}
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={5}>
              Required FW Version
            </Col>
            <Col sm={5}>
              {entitlement.requiresFWVers.length > 0 ? (
                entitlement.requiresFWVers.map((p) => (
                  <FormControl.Static>{p}</FormControl.Static>
                ))
              ) : (
                <FormControl.Static>-</FormControl.Static>
              )}
            </Col>
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Purpose
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.purpose}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Created By
            </Col>
            <Col sm={5}>
              <FormControl.Static>{entitlement.createdBy}</FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Licensed To
            </Col>
            <Col sm={9}>
              {entitlement.registrations.length > 0 && (
                <div>
                  <LicenseColumn componentClass={ControlLabel} sm={6}>
                    Product Id
                  </LicenseColumn>
                  <LicenseColumn componentClass={ControlLabel} sm={6}>
                    Licensed At
                  </LicenseColumn>
                  {entitlement.registrations.map((item) => {
                    return (
                      <LicenseRow>
                        <Col sm={6}>
                          {item.product_sap_number}
                          {item.serial_number}
                        </Col>
                        <Col sm={6}>{moment(item.created_at).format("L")}</Col>
                      </LicenseRow>
                    );
                  })}
                </div>
              )}
            </Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              State Flow
            </Col>
            <Col sm={7}>
              <ActivityState currentState={entitlement.status}></ActivityState>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default EntitlementDetail;
